import React from "react";

import { Button, Message } from "../BP2Components";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { addCartItem } from "../../appRedux/actions/Cart";
import { postCart } from "../../services/restAPI/RestApi";
import { fixedHTML } from "../AdvertisementItem/utils";
import { getCartId } from "../Widgets/DefaultWidgets/ShoppingBasketCardsWidget";

import IntlMessages from "@util/IntlMessages";
import MainTitleItem from "../AdvertisementItem/subComponents/MainTitleItem/MainTitleItem";
import KeyInfoItem from "../AdvertisementItem/subComponents/KeyInfoItem/KeyInfoItem";
import SubKeyInfoItem from "../AdvertisementItem/subComponents/SubKeyInfoItem/SubKeyInfoItem";
import SubtitleItem from "../AdvertisementItem/subComponents/SubtitleItem/SubtitleItem";
import DescriptionItem from "../AdvertisementItem/subComponents/DIscriptionItem/DescriptionItem";

import "./productItem.less";
import { handlePhotoColumn } from "../../util/Scripts";
import { Icon_ShoppingCart } from "../BP2Components/Icons/icons";

const ProductItem = ({
   columns,
   rows,
   item,
   mainTitle,
   subtitle,
   keyInfo,
   subKeyInfo,
   description,
   buttons,
   hasPhoto,
   photoColumn = "Zdjęcie",
   shopName,
   showButtonAddToCart,
   showMainTitleLabel,
   showSubtitleLabel,
   showDiscription,
   showKeyInfoLabel,
   showSubKeyInfoLabel,
}) => {
   const dispatch = useDispatch();
   const user = useSelector(({ user }) => user);
   const intl = useIntl();

   const addToCart = () => {
      if (user?.carts?.length && !localStorage.getItem("isPublicUserLogged")) {
         Message.loading(intl.formatMessage({ id: "global.loading" }), 0);
         const cartId = getCartId(user, shopName);
         const itemId = item?.item_id ? item?.item_id : item?.item_id?.id;
         postCart(shopName, cartId, itemId, 1, "addItem")
            .then(() => {
               dispatch(addCartItem(shopName, item));
               Message.destroy();
               Message.success(intl.formatMessage({ id: "shopping.basket.addedToCart" }));
            })
            .catch((err) => {
               Message.destroy();
               Message.error(intl.formatMessage({ id: err.response.data.message }));
            });
      } else {
         dispatch(addCartItem(shopName, item));
         Message.destroy();
         Message.success(intl.formatMessage({ id: "shopping.basket.addedToCart" }));
      }
   };

   const isSelectedColValid = (elem) => {
      if (columns.find((col) => col.title === elem) || elem === "-") return elem;
      else return "-";
   };

   const getTitleFromTechName = (techName) => {
      return columns.find((column) =>
         column.techName !== undefined ? column.techName === techName : false,
      )?.title;
   };

   mainTitle = isSelectedColValid(getTitleFromTechName(mainTitle));
   subtitle = isSelectedColValid(getTitleFromTechName(subtitle));
   keyInfo = isSelectedColValid(getTitleFromTechName(keyInfo));
   subKeyInfo = isSelectedColValid(getTitleFromTechName(subKeyInfo));
   description = isSelectedColValid(getTitleFromTechName(description));
   return rows ? (
      <div
         className={`gx-product-item product-item ${
            true ? "gx-product-vertical" : "gx-product-horizontal"
         }`}
      >
         {hasPhoto && item && (
            <div className="gx-product-image product-item-image">
               <div className="gx-grid-thumb-equal">
                  <span className="gx-link gx-grid-thumb-cover">
                     <img
                        alt={rows[subtitle]}
                        src={
                           handlePhotoColumn(item[photoColumn]?.[0]) !== "badUrl"
                              ? handlePhotoColumn(item[photoColumn][0])
                              : ""
                        }
                     />
                  </span>
               </div>
            </div>
         )}
         <div className="gx-product-container product-item-body">
            <MainTitleItem
               showTitle={showMainTitleLabel}
               value={(mainTitle !== "-" || mainTitle === null) && fixedHTML(rows[mainTitle])}
               title={mainTitle}
            />
            <KeyInfoItem
               showTitle={showKeyInfoLabel}
               value={(keyInfo !== "-" || keyInfo === null) && fixedHTML(rows[keyInfo])}
               title={keyInfo}
            />
            <SubKeyInfoItem
               showTitle={showSubKeyInfoLabel}
               value={(subKeyInfo !== "-" || subKeyInfo === null) && fixedHTML(rows[subKeyInfo])}
               title={subKeyInfo}
            />
            <SubtitleItem
               showTitle={showSubtitleLabel}
               value={(subtitle !== "-" || subtitle === null) && fixedHTML(rows[subtitle])}
               title={subtitle}
               column={columns.filter((col) => col?.title === subtitle)}
            />
            <DescriptionItem
               showTitle={showDiscription}
               value={(description !== "-" || subtitle === null) && fixedHTML(rows[description])}
               title={description}
            />
         </div>
         <div className="gx-product-footer product-item-footer">
            {showButtonAddToCart !== false && (
               <>
                  <Button
                     variant="raised"
                     onClick={addToCart}
                     className="product-item-addToCartButton"
                     buttonType="primary"
                  >
                     <Icon_ShoppingCart /> <IntlMessages id="productItem.addToCart" />
                  </Button>
               </>
            )}
            {buttons}
         </div>
      </div>
   ) : (
      ""
   );
};

export default ProductItem;
